import Image from "next/image";
import {
	Box,
	Button,
	Center,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerFooter,
	DrawerHeader,
	Badge,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
	HStack,
} from "@chakra-ui/react";
import { useState } from "react";
import React from "react";
import StatProgress from "./StatProgress";
import MountPanel from "./MountPanel";
import { Raider } from "../../../types/raider";

interface StatsDrawerProps {
	all_my_raiders: Raider[];
	raider: Raider;
	closeDrawer: () => void;
}

export default function StatsDrawer(props: StatsDrawerProps) {
	const [raider] = useState<Raider>(props.raider);
	const [all_my_raiders] = useState<Raider[]>(props.all_my_raiders);
	const [charTabIndex, setCharTabIndex] = React.useState(1);

	return (
		<DrawerContent>
			<DrawerCloseButton />
			<DrawerHeader>
				<HStack>
					<Badge variant="outline">{raider.attributes[1].value}</Badge>
					<Box>{raider.name}</Box>
				</HStack>
			</DrawerHeader>
			<DrawerBody>
				<Box size="xl" zIndex={1} className="avatar-preview-drawer">
					<Center>
						<Image
							src={raider.image}
							alt={raider.name}
							width="300"
							height="300"
						/>
					</Center>
				</Box>
				<Tabs
					mt={8}
					isFitted
					variant="enclosed-colored"
					index={charTabIndex}
					onChange={setCharTabIndex}
				>
					<TabList mb="1em">
						<Tab>Professions</Tab>
						<Tab>
							<Badge variant="outline">{}</Badge>&nbsp;Mount
						</Tab>
					</TabList>
					<TabPanels>
						<TabPanel>
							<Box mb="20px">
								<StatProgress
									raider={raider}
									professionId={1}
									professionName="Herbalism"
								/>
							</Box>
							<Box>
								<StatProgress
									raider={raider}
									professionId={2}
									professionName="Alchemy"
								/>
							</Box>
						</TabPanel>
						<TabPanel>
							<MountPanel raider={raider} all_my_raiders={all_my_raiders} />
						</TabPanel>
					</TabPanels>
				</Tabs>
			</DrawerBody>
			<DrawerFooter>
				<Button
					colorScheme="red"
					variant="outline"
					mr={3}
					onClick={props.closeDrawer}
				>
					Close
				</Button>
			</DrawerFooter>
		</DrawerContent>
	);
}
